const CollegePillActions = {
  ADD_COLLEGE_PILL: 'CollegePill.ADD_COLLEGE_PILL',
  REMOVE_COLLEGE_PILL: 'CollegePill.REMOVE_COLLEGE_PILL',
};

export default CollegePillActions;
